export const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5050"
    : "https://api.beatspot.app";
